import { GridItem } from 'src/components/common/grids';
import { Container, Title, SearchWrapper, DownButton, LabelStatus, DeleteButton } from '../styles';
import Table from '../../common/tables';
import { TableRow } from '../../common/tables/TableRow';
import { TableCell } from '../../common/tables/TableCell';
import { TableHeader } from '../../common/tables/TableHeader';
import Icon from '../../common/Icon';
import Pagination from 'src/components/common/pagination';
import { useAppDispatch, useAppSelector } from 'src/hooks/redux';
import { deleteAnalogReport, getAnalogInventoryProcessList, getAnalogReport } from 'src/redux/analog_inventory/thunks';

const statusCode = {
    ANALOG_PENDING: 0,
    ANALOG_SUCCESS: 1,
    ANALOG_FAIL: 2,
};

const getStatusStr = {
    [statusCode.ANALOG_PENDING]: 'pendiente',
    [statusCode.ANALOG_SUCCESS]: 'exitoso',
    [statusCode.ANALOG_FAIL]: 'fallo',
};

const Status = ({ status }) => <LabelStatus className={getStatusStr[status]}>{getStatusStr[status]}</LabelStatus>;


const ProcessList = ({ showModal }) => {
    const dispatch = useAppDispatch();
    const { list: { paginate, items }, loading } = useAppSelector((state) => state.analogInventory);
    const downloadReport = (id: string) => {
        dispatch(getAnalogReport({ id })).unwrap().then((res) => {
            if (res.data) {
                // Crear las filas del CSV
                const rows = res.data.map((item) => [item.id, item.process_id, item.code, item.message]);

                // Crear el contenido del CSV
                let csvContent = 'data:text/csv;charset=utf-8,';

                // Agregar las filas al contenido del CSV
                rows.forEach((row) => {
                    const csvRow = row.map((cell) => `"${cell}"`).join(',');
                    csvContent += csvRow + '\r\n';
                });
                // Crear un enlace de descarga
                const encodedUri = encodeURI(csvContent);
                const link = document.createElement('a');
                link.setAttribute('href', encodedUri);
                link.setAttribute('download', `reporte-${res.data[0].code}.csv`);
                document.body.appendChild(link);

                // Simular un clic en el enlace de descarga
                link.click();
            }
        });
    };

    const deleteReport = (id: string) => {
        dispatch(deleteAnalogReport({ id }));
    };

    const dateFormat = (fecha: string) => {
        return new Date(fecha)
            .toLocaleDateString('es-ES', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
            })
            .replace(/\//g, '-');
    };
    const onChangePageHandler = (page: number) => {
        dispatch(getAnalogInventoryProcessList({ page: Number(page) }));
    };

    return (
        <>
            <GridItem>
                <Title style={{ marginTop: '48px' }}>Historial de carga</Title>
            </GridItem>
            <Container className="process-list">
                <SearchWrapper>
                    <GridItem>
                        <Table>
                            <thead>
                                {['ID', 'Fecha creación', 'Nombre', 'Status', 'Cargados', 'Rechazados', 'Actualizados', 'Total', 'Reporte'].map(
                                    (item) => (
                                        <TableHeader key={item}>{item}</TableHeader>
                                    )
                                )}
                            </thead>
                            <tbody>
                                {items.map(({ id, created, name, status, loaded, rejected, total, updated }) => (
                                    <TableRow key={`row-codes-${id}`}>
                                        <TableCell>{id}</TableCell>
                                        <TableCell>{dateFormat(created)}</TableCell>
                                        <TableCell>{name}</TableCell>
                                        <TableCell>
                                            <Status status={status} />
                                        </TableCell>
                                        <TableCell>{loaded}</TableCell>
                                        <TableCell>{rejected}</TableCell>
                                        <TableCell>{updated}</TableCell>
                                        <TableCell>{total}</TableCell>
                                        <TableCell>
                                            {Number(status) !== statusCode.ANALOG_PENDING ? (
                                                <DownButton onClick={() => downloadReport(id)}>
                                                    <Icon icon="pcom-icon-circle-arrow-outline-down" />
                                                </DownButton>
                                            ) : (
                                                ''
                                            )}
                                            {Number(status) === statusCode.ANALOG_FAIL ? (
                                                <DeleteButton onClick={() => deleteReport(id)}>
                                                    <Icon icon="pcom-icon-delete" />
                                                </DeleteButton>
                                            ) : (
                                                ''
                                            )}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </tbody>
                        </Table>
                        {!loading && <Pagination paginate={paginate} onChangePage={onChangePageHandler} />}
                    </GridItem>
                </SearchWrapper>
            </Container>
        </>
    );
};

export default ProcessList;
